import { render, staticRenderFns } from "./UserMenuItem.vue?vue&type=template&id=5d42ad2d&"
import script from "./UserMenuItem.vue?vue&type=script&lang=js&"
export * from "./UserMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports